@if (!isLoading) {
  <div class="main-container" data-cy="ar-payment-plan-view">
    <div class="sub-container" data-cy="ar-payment-plan-view-sub-container">
      <div id="main-plan-container" data-cy="ar-payment-plan-view-main-container">
        <div class="invoice-header-container" data-cy="ar-payment-plan-view-header-container">
          <div class="invoice-header" data-cy="ar-payment-plan-view-header">
            Payment Plan
          </div>
        </div>
        <mat-divider data-cy="ar-payment-plan-view-divider-1"></mat-divider>
        <div class="invoice-sub-header" data-cy="ar-payment-plan-view-sub-header">
          <div class="date-field" data-cy="ar-payment-plan-view-description-field">
            <div class="date-header" data-cy="ar-payment-plan-view-description-header">Description: </div>
            <div class="date-data" data-cy="ar-payment-plan-view-description-data">
              {{ paymentPlan.Description }}
            </div>
          </div>
          <div class="status-field" data-cy="ar-payment-plan-view-status-field">
            <div class="date-header" data-cy="ar-payment-plan-view-status-header">Status: </div>
            <div class="date-data" data-cy="ar-payment-plan-view-status-data">
              {{ hasUnpaidItems ? (paymentPlan.isPatientAccepted ? 'Accepted' : 'Awaiting Approval') : 'Paid' }}
            </div>
          </div>
        </div>
        <mat-divider data-cy="ar-payment-plan-view-divider-2"></mat-divider>
        <div class="services-container" data-cy="ar-payment-plan-view-services-container">
          @for (columnHeader of dataInvoiceItem.columns; track columnHeader) {
            <div class="service-column"
              [class.hide-column]="!columnHeader.show"
              data-cy="ar-payment-plan-view-service-column">
              <div class="column-header" data-cy="ar-payment-plan-view-column-header">
                {{ columnHeader.title }}
              </div>
              @for (item of dataInvoiceItem.billableItems; track item) {
                <div class="column-item-display-value" [class.hide-column]="!item.showItem" data-cy="ar-payment-plan-view-column-item">
                  @if (columnHeader.pipe === 'date') {
                    <div data-cy="ar-payment-plan-view-date-item">
                      {{ item[columnHeader.key] | date }}
                    </div>
                  }
                  @if (columnHeader.pipe === 'currency') {
                    <div data-cy="ar-payment-plan-view-currency-item">
                      {{ item[columnHeader.key] | currency }}
                    </div>
                  }
                  @if (columnHeader.pipe === 'trim') {
                    <div data-cy="ar-payment-plan-view-trim-item">
                      {{ item[columnHeader.key] }}
                    </div>
                  }
                  @if (columnHeader.pipe === 'none') {
                    <div data-cy="ar-payment-plan-view-none-item">
                      {{ item[columnHeader.key] }}
                    </div>
                  }
                </div>
              }
            </div>
          }
        </div>
        <mat-divider data-cy="ar-payment-plan-view-divider-3"></mat-divider>
        <div class="invoice-sub-header" data-cy="ar-payment-plan-view-payments-header">
          <div class="date-field" data-cy="ar-payment-plan-view-payments-field">
            <div class="date-header" data-cy="ar-payment-plan-view-payments-label">Payments </div>
            <div class="date-data" data-cy="ar-payment-plan-view-payments-count">
              {{ dataInvoiceItem.paymentItems.length }}
            </div>
          </div>
        </div>
        <mat-divider data-cy="ar-payment-plan-view-divider-4"></mat-divider>
        <div class="services-container" data-cy="ar-payment-plan-view-payments-container">
          <!-- show the # of payments and cost -->
          @for (columnHeader of dataInvoiceItem.paymentColumns; track columnHeader) {
            <div class="service-column"
              [class.hide-column]="!columnHeader.show"
              data-cy="ar-payment-plan-view-payment-column">
              <div class="column-header" data-cy="ar-payment-plan-view-payment-header">
                {{ columnHeader.title }}
              </div>
              @for (item of dataInvoiceItem.paymentItems; track item) {
                <div class="column-item-display-value" [class.hide-column]="!item.showItem" data-cy="ar-payment-plan-view-payment-item">
                  @if (columnHeader.pipe === 'date') {
                    <div data-cy="ar-payment-plan-view-payment-date">
                      {{ item[columnHeader.key] | date }}
                    </div>
                  }
                  @if (columnHeader.pipe === 'currency') {
                    <div data-cy="ar-payment-plan-view-payment-currency">
                      {{ item[columnHeader.key] | currency }}
                    </div>
                  }
                  @if (columnHeader.pipe === 'trim') {
                    <div data-cy="ar-payment-plan-view-payment-trim">
                      {{ item[columnHeader.key] }}
                    </div>
                  }
                  @if (columnHeader.pipe === 'none') {
                    <div data-cy="ar-payment-plan-view-payment-none">
                      {{ item[columnHeader.key] }}
                    </div>
                  }
                </div>
              }
            </div>
          }
        </div>
        <mat-divider data-cy="ar-payment-plan-view-divider-5"></mat-divider>
        <div class="total-container" data-cy="ar-payment-plan-view-total-container">
          <div class="total-header" data-cy="ar-payment-plan-view-total-header">
            Total due:
          </div>
          <div class="total-data" data-cy="ar-payment-plan-view-total-data">
            {{ dataInvoiceItem.totalDue | currency }}
          </div>
        </div>
      </div>
    </div>
    <div class="form-container" data-cy="ar-payment-plan-view-form-container">
      <div class="action-container" data-cy="ar-payment-plan-view-action-container">
        <button mat-raised-button class="action-button" color="primary" (click)="generatePDF()" data-cy="ar-payment-plan-view-pdf-btn"><i class="material-icons">picture_as_pdf</i></button>
        @if (hasUnpaidItems && paymentPlan.isPatientAccepted) {
          <button mat-raised-button class="action-button" color="primary" (click)="makePayment()" data-cy="ar-payment-plan-view-payment-btn">Make a payment</button>
        }
        @if (!paymentPlan.isPatientAccepted) {
          <button mat-raised-button class="action-button" color="primary" (click)="approvePlan()" [disabled]="paymentPlan.isPatientAccepted" data-cy="ar-payment-plan-view-approve-btn">Approve plan</button>
        }
        <button mat-raised-button class="action-button" color="primary" (click)="close()" data-cy="ar-payment-plan-view-done-btn">Done</button>
      </div>
      @if (!paymentPlan.isPatientAccepted) {
        <div class="message" data-cy="ar-payment-plan-view-approve-message">
          Please approve the plan before making a payment
        </div>
      }
      @if (paymentPlan.isPatientAccepted && !hasUnpaidItems) {
        <div class="message" data-cy="ar-payment-plan-view-paid-message">
          This plan has been paid off. No further payment required.
        </div>
      }
      @if (paymentPlan.isPatientAccepted && hasUnpaidItems) {
        <div class="payment-form" data-cy="ar-payment-plan-view-payment-form">
          @if (!paymentIsDue) {
            <div class="message" data-cy="ar-payment-plan-view-early-payment-message">
              No payment is required at this time but you can still make an early payment.
            </div>
          }
          @if (paymentIsDue) {
            <div class="message" data-cy="ar-payment-plan-view-due-payment-message">
              Payment is now due. Please make a payment.
            </div>
          }
        </div>
      }
    </div>
  </div>
}

@if (isLoading) {
  <div class="spinner-container" data-cy="ar-payment-plan-view-spinner-container">
    <mat-spinner data-cy="ar-payment-plan-view-spinner"></mat-spinner>
  </div>
}
